import { IEntity } from '../interfaces/entity';
import { User } from './user';

export interface IUserSettingList{
  items: UserSetting[];
  totalCount: number;
}

export class UserSetting implements IEntity{
  id: number;
  uid: string;
  userId: number;
  name: string;
  value: string;
  user: User;

  constructor(userSetting?)
  {
      userSetting = userSetting || {};
      this.id = userSetting.id;
      this.uid = userSetting.uid; 
      this.userId = userSetting.userId;
      this.name = userSetting.name || '';
      this.value = userSetting.value || '';
      this.user = userSetting.user;
  }
}
